module.exports = __webpack_public_path__ + "img/mobile-app.65b423d5.svg";